// extracted by mini-css-extract-plugin
export default {"start":"StartPage_start__5cdqo","pos":"StartPage_pos__445zL"};